import React from 'react'

const Seo = () => {
  return (
    <div>
      <h2> Hi I am Digital Marketing and I have colletion of Social , Seo and Performance pages </h2>
    </div>
  )
}

export default Seo
